import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeftRight } from "lucide-react";
import aiSecurityBg from "@/assets/ai-security-network-bg.jpg";

const AISecurityBanner = () => {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${aiSecurityBg})` }}
      />
      
      {/* Dark overlay for better text visibility */}
      <div className="absolute inset-0 bg-black/40" />
      
      <div className="container mx-auto px-4 md:px-6 relative">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-row items-center justify-between gap-4 md:gap-8 lg:gap-12">
            {/* Left side - AI Security */}
            <div className="flex-1 text-center lg:text-right">
              <h3 className="text-2xl md:text-4xl xl:text-5xl font-bold text-white tracking-tight">
                AI Security
              </h3>
              <p className="text-xs md:text-base text-white mt-2">
                Protecting your business with AI
              </p>
            </div>

            {/* Center - Bidirectional Arrow */}
            <div className="flex items-center justify-center px-4 md:px-8">
              <ArrowLeftRight className="w-8 h-8 md:w-16 md:h-16 text-[#8932c8]" strokeWidth={2.5} />
            </div>

            {/* Right side - Security for AI */}
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-2xl md:text-4xl xl:text-5xl font-bold text-white tracking-tight">
                Security for AI
              </h3>
              <p className="text-xs md:text-base text-white mt-2">
                Safeguarding AI operations
              </p>
            </div>
          </div>

          {/* Description and CTA Buttons */}
          <div className="flex flex-col items-center mt-12 space-y-6">
            <p className="text-base md:text-lg text-white text-center max-w-3xl px-4">
              AuraXP operates on two intelligent fronts, defending your enterprise autonomously while securing it from uncontrolled AI usage.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-[#8932c8] hover:bg-[#8932c8]/90 text-white font-semibold px-10 py-6 text-base shadow-lg shadow-[#8932c8]/20 hover:shadow-xl hover:shadow-[#8932c8]/30 transition-all"
                onClick={() => window.open('https://outlook.office.com/bookwithme/user/3c14c6b9047b45dfb64e4bc9045f29dd@spharaka.com/meetingtype/p0-SnGKD_EqEPlSvi_wdNg2?anonymous&ismsaljsauthenabled&ep=mlink', '_blank')}
              >
                Request Demo
              </Button>
              <Button
                size="lg"
                className="bg-[#8932c8] hover:bg-[#8932c8]/90 text-white font-semibold px-10 py-6 text-base shadow-lg shadow-[#8932c8]/20 hover:shadow-xl hover:shadow-[#8932c8]/30 transition-all"
                onClick={() => window.location.href = '/products/auraxp'}
              >
                Explore AuraXP
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AISecurityBanner;
